module.exports = __webpack_public_path__ + "img/35.c25bf7b5.png";